export default __webpack_public_path__ + "static/media/iconInfo.b04cd54f.svg";